import LazyLoading from "./common/lazyLoading";
import LoadPurchase from "./common/loadPurchase.js";
import CartDrawer from "./common/cartDrawer";
import Header from "./common/header";
import Webforms from "./common/webforms";
import Products from "./components/purchase/products";
import { NewsletterComponent } from "./components/vndaComponents.js";
import { backToTop, setSearch } from "./components/utilities";
import Californio from "./californio/californio.js";

function updateWhatsappWidgetText() {
  const oldText = "Clique aqui e fale com Sarah Chofakian";
  const newText = "Sarah Concierge 24h";
  const oldSpacingClass = "_1KI6AK9e6nfBQRogk_fA7E";
  const newSpacingClass = "_1znduFh4vW9oJTDiBzpYnu";
  const textClass = "_2OsIQySFuBsRV67RYnH8dR";
  const contentRowClass = "jX66Xx7xQW9rBQLTUTyf8";
  const preHideStyleId = "whatsapp-widget-prehide-style";

  const enablePreHide = () => {
    if (document.getElementById(preHideStyleId)) {
      return;
    }

    const style = document.createElement("style");
    style.id = preHideStyleId;
    style.textContent = `.${contentRowClass} { display: none !important; }`;
    document.head.appendChild(style);
  };

  const disablePreHide = () => {
    const style = document.getElementById(preHideStyleId);
    if (style) {
      style.remove();
    }
  };

  enablePreHide();

  const replaceText = () => {
    const textNode = Array.from(
      document.querySelectorAll(`span.${textClass}`),
    ).find(
      (span) =>
        span.textContent &&
        [oldText, newText].includes(span.textContent.trim()),
    );

    if (!textNode) {
      return false;
    }

    textNode.textContent = newText;

    const spacingElement = textNode.closest(
      `.${oldSpacingClass}, .${newSpacingClass}`,
    );
    if (spacingElement && spacingElement.classList.contains(oldSpacingClass)) {
      spacingElement.classList.remove(oldSpacingClass);
      spacingElement.classList.add(newSpacingClass);
    }

    const contentRowElement = textNode.closest(`.${contentRowClass}`);
    if (contentRowElement) {
      contentRowElement.style.setProperty(
        "justify-content",
        "start",
        "important",
      );
      contentRowElement.style.setProperty("padding", "0 0 0 28px", "important");
      contentRowElement.style.setProperty("display", "flex", "important");
    }

    disablePreHide();

    return true;
  };

  if (replaceText()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (replaceText()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Evita observer ativo indefinidamente se o widget nao carregar.
  setTimeout(() => {
    observer.disconnect();
    disablePreHide();
  }, 20000);
}

// ==========================================
// Inicialização
// ==========================================
console.log(
  "%cOlist - Soluções de vendas online e Serviços de E-commerce",
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;',
);

window.addEventListener("DOMContentLoaded", () => {
  Header.init();
  LazyLoading.init();
  LoadPurchase.init();
  CartDrawer.init();
  Webforms.init();
  NewsletterComponent.init();
  Products.init();
  setSearch();
  backToTop();
  // updateWhatsappWidgetText();
  Californio.init();
});
